import axios from "axios";
import React, { useState } from "react";
import { Axios } from "../../../../api";
import { BiLoaderAlt } from "react-icons/bi";
import { BASE_URL } from "../../../../constants";

const ExportExcel = ({ url, text, className }) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    let cancel_request;

    const getData = async () => {
        setLoading(true);
        setError(false);
        cancel_request = axios.CancelToken.source();
        try {
            const result = await Axios.get(`${url}`, {
                cancelToken: cancel_request.token
            });

            // setData(result.data.payload);
            // setCount(result.data.count);
            setLoading(false)
            cancel_request = null

        } catch (e) {
            if (e.response) {
                setError(JSON.stringify(e.response.data.description));
            } else if (axios.isCancel) {

            }
            else {
                setError("Network Error");
            }
            setLoading(false)
        }
    }

    return (
        <>
        <a 
            target="_blank"
            className={`${className ? className : '!w-32'} btn-small ${loading ? 'bg-gray-400' : 'bg-primary'} ${loading ? 'cursor-not-allowed' : ''} text-white !text-sm`} 
            href={`${BASE_URL}${url.trim()}`}
            download
        >
            {text}
        </a>
        </>
    )
};

export default ExportExcel;